import { RouteConfig } from 'vue-router';
import PSAMainPage from './psa-main-page.vue';
export const PSAIntegrationLandingPageRoute: RouteConfig = {// tslint:disable-line:variable-name
  path: 'psa-integration',
  component: PSAMainPage,
};

export function getDefaultParams() {
  return {};
}

export default PSAIntegrationLandingPageRoute;
